import React from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { ReactComponent as CheckboxRound } from '@assets/home/checkbox-round.svg';

import { useStyles } from './styles';

export const Benefit = ({ title, description }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" style={{ gap: '12px', maxWidth: '422px', width: '100%' }}>
      <CheckboxRound />
      <Typography className={classes.title}>{title}</Typography>
      <Box className={classes.divider} />
      <Typography style={{ fontSize: 14 }} color="#040C14">
        {description}
      </Typography>
    </Box>
  );
};
